module.exports = __webpack_public_path__ + "img/Monte_Kope_34.c7534989.jpg";